import { addErrorState } from './debug-state-actions';

export function handleError({ store, setProps, appParams, captureToSentry }) {
  return error => {
    const state = store && store.getState();
    console.error('--- error in createForumAppController ---');
    console.error(error);
    if (captureToSentry) {
      captureToSentry(error);
    }
    setProps({
      state,
      cssBaseUrl: appParams.baseUrls.staticsBaseUrl,
      workerError: error.toString(),
      wasWorkerErrorCaptured: captureToSentry !== undefined,
    });
    store && store.dispatch(addErrorState(error));
  };
}
